<template>
  <v-dialog
    v-model="deliveryHasArrivedDialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="50%"
    persistent
  >
    <v-card>
      <v-toolbar
        dark
        color="secondary"
        class="elevation-0"
      >
        <v-btn
          icon
          dark
          @click.native="deliveryHasArrivedDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>דווח על הגעה לחנות</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary darken-2"
          depressed
          large
          :loading="loading"
          :disabled="loading"
          @click="send"
        >
          ביצוע הדיווח
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-select
          :items="stores"
          item-value="_id"
          item-text="title"
          label="חנות"
          v-model="store"
        ></v-select>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getApi } from "@/api";
import Mixins from "@/mixins/mixins";

export default {
  data() {
    return {
      loading: false,
      imeiList: "",
      store: null,
      boxType: null
    };
  },

  computed: {
    deliveryHasArrivedDialog: {
      get() {
        return this.$store.state.deliveryHasArrivedDialog;
      },
      set(isActive) {
        this.$store.commit("TOGGLE_DELIVERY_HAS_ARRIVED_DIALOG", isActive);
      }
    },
    storeBoxTypes() {
      if (this.store) {
        let store = this.$store.state.entities.stores[this.store];
        if (store) {
          let boxTypes = store.boxTypes;
          if (boxTypes) {
            return boxTypes
              .map(item => {
                return this.$store.state.entities.boxTypes[item];
              })
              .filter(item => {
                return !!item;
              });
          }
        }
      }
      return [];
    }
  },

  methods: {
    send() {
      this.loading = true;

      getApi()
        .then(api => {
          let params = {
            store: this.store
          };
          return api.post(
            `/deliveries/${this.deliveryId}/set-as-arrived`,
            params
          );
        })
        .then(() => {
          this.deliveryHasArrivedDialog = false;
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: "הדיווח הושלם בהצלחה",
            color: "success"
          });
        })
        .catch(err => {
          this.showError(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  props: ["deliveryId", "stores"],

  mixins: [Mixins],

  watch: {
    deliveryHasArrivedDialog: {
      handler: function(val) {
        if (!val) {
          this.store = null;
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
